<template>
  <div
    class="query-result-text"
    :class="[variant]"
  >
    <div class="informative"></div>
    <div class="truncate">{{ text }}</div>
  </div>
</template>

<script>
import capitalize from '@/support/filters/capitalize';

export default {
  name: 'QueryResultText',

  props: {
    result: {
      required: true,
      type: String,
    },
  },

  computed: {
    variant() {
      const variantByResult = {
        positiva: '-danger',
        positivo: '-danger',
        negativa: '-success',
        negativo: '-success',
        optante: '-success',
        regular: '-success',
        cadastrado: '-success',
        cadastrada: '-success',
        positiva_negativa: '-warning',
        atencao: '-warning',
        indefinida: '-info',
        indefinido: '-info',
        baixada: '-info',
        erro: '-danger',
        default: '-warning',
      };

      return variantByResult[this.result] || variantByResult.default;
    },

    text() {
      return capitalize(this.result).split('_').join(' ');
    },
  },
};
</script>

<style lang="scss" scoped>
  .query-result-text {
    @apply flex;
    @apply items-center;

    > .informative {
      @apply flex-shrink-0;
      @apply w-2;
      @apply h-2;
      @apply mr-3;
      @apply rounded-full;
    }

    &.-success {
      .informative {
        @apply bg-green-500;
      }
    }

    &.-danger {
      .informative {
        @apply bg-red-500;
      }
    }

    &.-warning {
      .informative {
        @apply bg-yellow-500;
      }
    }

    &.-info {
      .informative {
        @apply bg-blue-500;
      }
    }
  }
</style>
